"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtendedPreview = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_intl_1 = require("react-intl");
var PreviewRows_1 = tslib_1.__importDefault(require("../shared/PreviewRows"));
var ExtendedPreview = /** @class */ (function (_super) {
    tslib_1.__extends(ExtendedPreview, _super);
    function ExtendedPreview() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            expanded: false,
        };
        _this.openExtendedPreview = function () {
            _this.setState({ expanded: true });
        };
        return _this;
    }
    ExtendedPreview.prototype.render = function () {
        var expanded = this.state.expanded;
        var _a = this.props, format = _a.format, separators = _a.separators;
        return (react_1.default.createElement("div", { className: "gd-measure-format-extended-preview s-custom-format-dialog-extended-preview" },
            react_1.default.createElement("div", { className: classnames_1.default("s-custom-format-dialog-extended-preview-button gd-measure-format-button", {
                    hidden: expanded,
                }), onClick: this.openExtendedPreview },
                react_1.default.createElement("div", { className: "gd-icon-navigateright gd-measure-format-button-icon-left" }),
                react_1.default.createElement("span", null,
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "measureNumberCustomFormatDialog.extendedPreview.button" }))),
            expanded && react_1.default.createElement(PreviewRows_1.default, { format: format, separators: separators })));
    };
    return ExtendedPreview;
}(react_1.default.Component));
exports.ExtendedPreview = ExtendedPreview;
//# sourceMappingURL=ExtendedPreview.js.map